import axios from "./api-client";
import {Receipt} from "../model/Participant";

export const updateReceipt = (token: string | undefined, eventSlug: string, data: any, handleData: (receipt: Receipt) => void, onError?: (error: string) => void) => {
    const url = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL + `/api/events/${eventSlug}/receipts/` : '';
    const config = {
        headers: {
            'Accept-Content': 'application/json',
            'Authorization': 'Bearer ' + token
        }
    }
    const request = {
        id: data.id,
        receipt_date: data.date,
        receipt_number: data.number,
        amount: data.amount,
        shop_name: data.shopName
    }
    axios.put(url, request, config).then((response) => {
        if (response.status == 200) {
            handleData && handleData(response.data as Receipt);
        } else {
            onError && onError(JSON.stringify(response.data));
        }
    }).catch((error) => {
        console.error(error.response.data ? error.response.data.message : error);
        onError && onError(error.response.data ? error.response.data.message : "Błąd serwera!");
    })
}
